<template>
  <div>
    <CrudList
      title="Autos"
      storeName="Cars"
      parentStoreName="Users"
      parentUrlKey="user_id"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      labelBack="Atrás"
    >
      <template v-slot:picture="{ item }">
        <v-row align="center" justify="center" class="pt-2">
          <v-col cols="12" v-if="item.car_model && item.car_model.car_picture">
              <img :src="item.car_model.car_picture" alt="" width="150">
          </v-col>
        </v-row>
      </template>
      <template v-slot:cars="{ item }">
        <v-row class="pt-2 ms-1">
          {{ item.car_model.name ? item.car_model.name : '' }}
        </v-row>
      </template>
      <template v-slot:car_model_id="{ item }">
        <v-row class="pt-2 ms-0">
          {{ item.car_model.brand.name ? item.car_model.brand.name : '' }}
        </v-row>
      </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
